var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return _extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== 'function' && b !== null) throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
    _extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import * as topojson from 'topojson-client';
import INDIA_JSON from './data/india.json';
import MapElements from './components/MapElements/index';
import HoverInfo from './components/HoverInfo';
import TitleStyle from './components/TitleStyle';
var TOPO_INDIA_DATA = topojson.feature(
// @ts-ignore
INDIA_JSON, INDIA_JSON.objects['india']
// @ts-ignore
).features;
var DEFAULT_MAP_LAYOUT = {
  title: '',
  hoverName: '',
  legendTitle: '',
  startColor: 'orange',
  endColor: 'red',
  hoverTitle: 'Count',
  noDataColor: '#f5f5f5',
  borderColor: '#8D8D8D',
  hoverColor: 'green'
};
var DatamapBox = /** @class */function (_super) {
  __extends(DatamapBox, _super);
  function DatamapBox(props) {
    var _this = _super.call(this, props) || this;
    _this.state = {
      infoWindowPosition: {
        x: 0,
        y: 0
      },
      isInfoWindowActive: false,
      activeState: {
        name: '',
        value: 0
      },
      regionData: _this.props.regionData,
      mapLayout: __assign(__assign({}, DEFAULT_MAP_LAYOUT), _this.props.mapLayout)
    };
    _this.mouseMoveOnDatamap = _this.mouseMoveOnDatamap.bind(_this);
    _this.mouseEnterOnDatamap = _this.mouseEnterOnDatamap.bind(_this);
    _this.mouseLeaveDatamap = _this.mouseLeaveDatamap.bind(_this);
    _this.mouseEnterOnState = _this.mouseEnterOnState.bind(_this);
    _this.calculateExtremeValues = _this.calculateExtremeValues.bind(_this);
    return _this;
  }
  DatamapBox.prototype.componentDidMount = function () {
    window.addEventListener('scroll', this.mouseLeaveDatamap);
  };
  DatamapBox.prototype.componentWillUnmount = function () {
    window.removeEventListener('scroll', this.mouseLeaveDatamap);
  };
  DatamapBox.getDerivedStateFromProps = function (props, state) {
    if (props.regionData !== state.regionData) {
      return {
        regionData: props.regionData
      };
    } else if (props.mapLayout !== state.mapLayout) {
      return {
        mapLayout: __assign(__assign({}, DEFAULT_MAP_LAYOUT), props.mapLayout)
      };
    }
    return null;
  };
  DatamapBox.prototype.calculateExtremeValues = function (regions) {
    var regionValues = Object.values(regions).map(function (region) {
      var _a;
      return (_a = region.value) !== null && _a !== void 0 ? _a : region;
    });
    return {
      min: Math.min.apply(Math, regionValues),
      max: Math.max.apply(Math, regionValues)
    };
  };
  DatamapBox.prototype.mouseMoveOnDatamap = function (e) {
    this.setState({
      infoWindowPosition: {
        x: e.clientX,
        y: e.clientY
      },
      isInfoWindowActive: true
    });
  };
  DatamapBox.prototype.mouseEnterOnDatamap = function () {
    this.setState({
      isInfoWindowActive: true
    });
  };
  DatamapBox.prototype.mouseLeaveDatamap = function () {
    this.setState({
      isInfoWindowActive: false
    });
  };
  DatamapBox.prototype.mouseEnterOnState = function (name, value) {
    this.setState({
      activeState: {
        name: name,
        value: value
      },
      isInfoWindowActive: true
    });
  };
  DatamapBox.prototype.render = function () {
    return React.createElement(React.Fragment, null, React.createElement(MapElements, {
      topoData: TOPO_INDIA_DATA,
      mapLayout: this.state.mapLayout,
      regionData: this.state.regionData,
      extremeValues: this.calculateExtremeValues(this.state.regionData),
      mouseMoveOnDatamap: this.mouseMoveOnDatamap,
      mouseEnterOnDatamap: this.mouseEnterOnDatamap,
      mouseLeaveDatamap: this.mouseLeaveDatamap,
      mouseEnterOnState: this.mouseEnterOnState,
      infoWindowPos: this.state.infoWindowPosition
    }), this.state.mapLayout.hoverName || this.state.activeState.name ? React.createElement(HoverInfo, {
      active: this.state.isInfoWindowActive,
      position: this.state.infoWindowPosition,
      name: this.state.mapLayout.hoverName || this.state.activeState.name,
      value: this.state.activeState.value,
      valueTitle: this.state.mapLayout.hoverTitle || '',
      hoverComponent: this.props.hoverComponent
    }) : null, React.createElement(TitleStyle, null));
  };
  DatamapBox.defaultProps = {
    regionData: {}
  };
  return DatamapBox;
}(React.Component);
export default DatamapBox;